import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { updateAppuserGroup } from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { BASE_IMAGES_URL, COMMON_FAIL_MESSAGE } from "Constants";
import LocaleStrings from "Languages";

class AppuserList extends Component {
  constructor(props) {
    super(props);

    this.state = { userGroups: props.appUser.usercategory.split(",") };
  }

  handleUserCategory = (item) => {
    let { session, appUser, currentPage, userCategoryList } = this.props;
    var array = this.state.userGroups;

    if (_.includes(array, item.id.toString())) {
      if (array.length > 1) {
        var filter = _.filter(array, function (n) {
          return n != item.id;
        });
        array = filter;

        // Update appuser group
        var adminDetails = _.filter(userCategoryList.data, (obj) => {
          return obj.type == "admin";
        });

        var values = {
          appuserid: appUser.appuserid,
          eventid: appUser.eventid,
          usercategory: array.join(","),
          isadmin: array.join(",").search(adminDetails[0].id) >= 0 ? 1 : 0,
        };
        this.props.updateAppuserGroup(session, values, (response) => {
          if (response.success) {
            this.props.showSuccess(
              LocaleStrings.user_appuser_group_success_update
            );
            this.props.pagination(currentPage);
            this.setState({ userGroups: array });
          } else {
            this.props.showError(COMMON_FAIL_MESSAGE);
          }
        });
      } else {
        this.props.showError(
          LocaleStrings.user_appuser_group_validation_min1_required
        );
      }
    } else {
      array = [...array, item.id.toString()];

      // Update appuser group
      var adminDetails = _.filter(userCategoryList.data, (obj) => {
        return obj.type == "admin";
      });

      var values = {
        appuserid: appUser.appuserid,
        eventid: appUser.eventid,
        usercategory: array.join(","),
        isadmin: array.join(",").search(adminDetails[0].id) >= 0 ? 1 : 0,
      };
      this.props.updateAppuserGroup(session, values, (response) => {
        if (response.success) {
          this.props.showSuccess(
            LocaleStrings.user_appuser_group_success_update
          );
          this.props.pagination(currentPage);
          this.setState({ userGroups: array });
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    }
  };

  _renderCategory = () => {
    let { session, appUser, userCategoryList } = this.props;
    let { userGroups } = this.state;

    var adminArr = _.filter(userCategoryList.data, (o) => {
      return o.type === "admin";
    });

    return _.map(userCategoryList.data, (item, index) => {
      return (
        <div
          key={`int_key${index}`}
          className={`custom-text2-primary-normal ${
            _.includes(userGroups, item.id.toString()) &&
            // item.id == adminArr[0].id &&
            item.type === "admin" &&
            appUser.appuserid == session.userid
              ? "selected-interest bg-disabled cursor-disbaled"
              : _.includes(userGroups, item.id.toString())
              ? "selected-interest"
              : "interests"
          }`}
          onClick={
            _.includes(userGroups, item.id.toString()) &&
            item.type === "admin" &&
            appUser.appuserid == session.userid
              ? null
              : () => this.handleUserCategory(item)
          }
        >
          {item.groupname}
          {_.includes(userGroups, item.id.toString()) ? (
            <span>
              &nbsp; <i className="fa fa-check" aria-hidden="true"></i>
            </span>
          ) : (
            ""
          )}
        </div>
      );
    });
  };

  render() {
    var { session, appUser } = this.props;
    var profileImageUrl = "../../style/images/custom-icons/user_2.png";
    if (appUser.profileurl && appUser.profileurl !== "") {
      profileImageUrl = `${BASE_IMAGES_URL}/${appUser.profileurl}?api_key=${session.apiKey}&session_token=${session.sessionToken}`;
    }
    var style = {
      width: "30px",
      height: "30px",
      backgroundImage: `url(${profileImageUrl})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      borderRadius: "10px",
      backgroundPosition: "50% 50%",
    };

    return (
      <tr>
        <td>
          <div className="d-flex">
            <div style={{ marginRight: 15 }}>
              <div style={style}></div>
            </div>
            <div>
              {appUser.username}
              <div className="custom-text2-theme-normal">{appUser.email}</div>
            </div>
          </div>
        </td>
        <td>
          <div className="">
            <div className="interest-section">{this._renderCategory()}</div>
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    userCategoryList: state.userCategoryList,
  };
};

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  updateAppuserGroup,
})(AppuserList);
